/**
 * Submitting component that displays a loading message during form submission.
 * Only renders when the submitting prop is true.
 *
 * @param props - Component props
 * @param props.submitting - Whether the form is currently submitting
 * @returns {JSX.Element | null} The submitting message or null
 */
export const Submitting = ({ submitting }: { submitting?: boolean }) =>
  submitting ? <div>Submitting...</div> : null;
